module.exports = __webpack_public_path__ + "media/images/icon__nativeAppShare@2x-d6b81668bb4e08f430ec26bb694bce2a.png";